import PropTypes from 'prop-types';
import React from 'react';

import { ICON_ALIASES } from '_constants/icons';

import AmexSvg from './assets/AmexSvg';
import ArchiveTickSvg from './assets/ArchiveTickSvg';
import ArrowDownCircleSvg from './assets/ArrowDownCircleSvg';
import ArrowLeftSvg from './assets/ArrowLeftSvg';
import ArrowRightSvg from './assets/ArrowRightSvg';
import CalendarSvg from './assets/CalendarSvg';
import CallSvg from './assets/CallSvg';
import CallingSvg from './assets/CallingSvg';
import CardReceiveSvg from './assets/CardReceiveSvg';
import CardSendSvg from './assets/CardSendSvg';
import CardSvg from './assets/CardSvg';
import CategorySvg from './assets/CategorySvg';
import CheckboxFilledSvg from './assets/CheckboxFilledSvg';
import CheckboxSvg from './assets/CheckboxSvg';
import ChevronDownSvg from './assets/ChevronDownSvg';
import ChevronUpSvg from './assets/ChevronUpSvg';
import CloseSquareSvg from './assets/CloseSquareSvg';
import CloseSvg from './assets/CloseSvg';
import DiscoverSvg from './assets/DiscoverSvg';
import DocumentEditSvg from './assets/DocumentEditSvg';
import DocumentNormalSvg from './assets/DocumentNormalSvg';
import DocumentSvg from './assets/DocumentSvg';
import DocumentTextSvg from './assets/DocumentTextSvg';
import DollarSquareSvg from './assets/DollarSquareSvg';
import DropSvg from './assets/DropSvg';
import EditSvg from './assets/EditSvg';
import EyeSlashSvg from './assets/EyeSlashSvg';
import EyeSvg from './assets/EyeSvg';
import GrowthSvg from './assets/GrowthSvg';
import HomeSvg from './assets/HomeSvg';
import InfoCircleSvg from './assets/InfoCircleSvg';
import LinkSvg from './assets/LinkSvg';
import MastercardSvg from './assets/MastercardSvg';
import MessageSvg from './assets/MessageSvg';
import MoneyReceiveSvg from './assets/MoneyReceiveSvg';
import MoneySendSvg from './assets/MoneySendSvg';
import PlusSvg from './assets/PlusSvg';
import ProfileCircleSvg from './assets/ProfileCircleSvg';
import ProfileTickSvg from './assets/ProfileTickSvg';
import RadioOffSvg from './assets/RadioOffSvg';
import RadioOnSvg from './assets/RadioOnSvg';
import RateDownSvg from './assets/RateDownSvg';
import RateUpSvg from './assets/RateUpSvg';
import ReceiptDiscountSvg from './assets/ReceiptDiscountSvg';
import ReceiptSvg from './assets/ReceiptSvg';
import SlashSvg from './assets/SlashSvg';
import SmsSvg from './assets/SmsSvg';
import StarSvg from './assets/StarSvg';
import TestcardSvg from './assets/TestcardSvg';
import TickCircleFilledSvg from './assets/TickCircleFilledSvg';
import TickCircleSvg from './assets/TickCircleSvg';
import TickSquareSvg from './assets/TickSquareSvg';
import TickSvg from './assets/TickSvg';
import TrashSvg from './assets/TrashSvg';
import UsersSvg from './assets/UsersSvg';
import VisaSvg from './assets/VisaSvg';

const icons = {
  [ICON_ALIASES.arrowLeft]: ArrowLeftSvg,
  [ICON_ALIASES.arrowRight]: ArrowRightSvg,
  [ICON_ALIASES.arrowDownCircle]: ArrowDownCircleSvg,
  [ICON_ALIASES.closeSquare]: CloseSquareSvg,
  [ICON_ALIASES.tickSquare]: TickSquareSvg,
  [ICON_ALIASES.link]: LinkSvg,
  [ICON_ALIASES.chevronDown]: ChevronDownSvg,
  [ICON_ALIASES.chevronUp]: ChevronUpSvg,
  [ICON_ALIASES.category]: CategorySvg,
  [ICON_ALIASES.moneyReceive]: MoneyReceiveSvg,
  [ICON_ALIASES.moneySend]: MoneySendSvg,
  [ICON_ALIASES.receiptDiscount]: ReceiptDiscountSvg,
  [ICON_ALIASES.receipt]: ReceiptSvg,
  [ICON_ALIASES.call]: CallSvg,
  [ICON_ALIASES.calling]: CallingSvg,
  [ICON_ALIASES.edit]: EditSvg,
  [ICON_ALIASES.sms]: SmsSvg,
  [ICON_ALIASES.growth]: GrowthSvg,
  [ICON_ALIASES.drop]: DropSvg,
  [ICON_ALIASES.checkbox]: CheckboxSvg,
  [ICON_ALIASES.checkboxFilled]: CheckboxFilledSvg,
  [ICON_ALIASES.home]: HomeSvg,
  [ICON_ALIASES.rateUp]: RateUpSvg,
  [ICON_ALIASES.rateDown]: RateDownSvg,
  [ICON_ALIASES.calendar]: CalendarSvg,
  [ICON_ALIASES.document]: DocumentSvg,
  [ICON_ALIASES.documentText]: DocumentTextSvg,
  [ICON_ALIASES.archiveTick]: ArchiveTickSvg,
  [ICON_ALIASES.star]: StarSvg,
  [ICON_ALIASES.profileCircle]: ProfileCircleSvg,
  [ICON_ALIASES.users]: UsersSvg,
  [ICON_ALIASES.documentNormal]: DocumentNormalSvg,
  [ICON_ALIASES.profileTick]: ProfileTickSvg,
  [ICON_ALIASES.eye]: EyeSvg,
  [ICON_ALIASES.eyeSlash]: EyeSlashSvg,
  [ICON_ALIASES.close]: CloseSvg,
  [ICON_ALIASES.dollarSquare]: DollarSquareSvg,
  [ICON_ALIASES.cardReceive]: CardReceiveSvg,
  [ICON_ALIASES.cardSend]: CardSendSvg,
  [ICON_ALIASES.card]: CardSvg,
  [ICON_ALIASES.amex]: AmexSvg,
  [ICON_ALIASES.discover]: DiscoverSvg,
  [ICON_ALIASES.mastercard]: MastercardSvg,
  [ICON_ALIASES.visa]: VisaSvg,
  [ICON_ALIASES.testcard]: TestcardSvg,
  [ICON_ALIASES.plus]: PlusSvg,
  [ICON_ALIASES.tickCircle]: TickCircleSvg,
  [ICON_ALIASES.tickCircleFilled]: TickCircleFilledSvg,
  [ICON_ALIASES.infoCircle]: InfoCircleSvg,
  [ICON_ALIASES.slash]: SlashSvg,
  [ICON_ALIASES.tick]: TickSvg,
  [ICON_ALIASES.documentEdit]: DocumentEditSvg,
  [ICON_ALIASES.trash]: TrashSvg,
  [ICON_ALIASES.radioOff]: RadioOffSvg,
  [ICON_ALIASES.radioOn]: RadioOnSvg,
  [ICON_ALIASES.message]: MessageSvg,
};

const Icon = ({ uniqueKey = '', alias, color, opacity, mixBlendMode, width, height }) => {
  const Icon = icons[alias];

  if (!Icon) {
    return null;
  }

  return (
    <Icon
      uniqueKey={uniqueKey}
      color={color}
      opacity={opacity}
      mixBlendMode={mixBlendMode}
      width={width}
      height={height}
    />
  );
};

Icon.propTypes = {
  uniqueKey: PropTypes.string,
  alias: PropTypes.oneOf([
    ICON_ALIASES.arrowLeft,
    ICON_ALIASES.arrowRight,
    ICON_ALIASES.arrowDownCircle,
    ICON_ALIASES.closeSquare,
    ICON_ALIASES.tickSquare,
    ICON_ALIASES.link,
    ICON_ALIASES.chevronDown,
    ICON_ALIASES.chevronUp,
    ICON_ALIASES.category,
    ICON_ALIASES.moneyReceive,
    ICON_ALIASES.moneySend,
    ICON_ALIASES.receiptDiscount,
    ICON_ALIASES.receipt,
    ICON_ALIASES.call,
    ICON_ALIASES.calling,
    ICON_ALIASES.edit,
    ICON_ALIASES.sms,
    ICON_ALIASES.growth,
    ICON_ALIASES.drop,
    ICON_ALIASES.checkbox,
    ICON_ALIASES.checkboxFilled,
    ICON_ALIASES.home,
    ICON_ALIASES.rateUp,
    ICON_ALIASES.rateDown,
    ICON_ALIASES.calendar,
    ICON_ALIASES.document,
    ICON_ALIASES.documentText,
    ICON_ALIASES.archiveTick,
    ICON_ALIASES.star,
    ICON_ALIASES.profileCircle,
    ICON_ALIASES.users,
    ICON_ALIASES.documentNormal,
    ICON_ALIASES.profileTick,
    ICON_ALIASES.eye,
    ICON_ALIASES.eyeSlash,
    ICON_ALIASES.close,
    ICON_ALIASES.dollarSquare,
    ICON_ALIASES.cardReceive,
    ICON_ALIASES.cardSend,
    ICON_ALIASES.card,
    ICON_ALIASES.amex,
    ICON_ALIASES.discover,
    ICON_ALIASES.mastercard,
    ICON_ALIASES.visa,
    ICON_ALIASES.testcard,
    ICON_ALIASES.plus,
    ICON_ALIASES.tickCircle,
    ICON_ALIASES.tickCircleFilled,
    ICON_ALIASES.infoCircle,
    ICON_ALIASES.slash,
    ICON_ALIASES.tick,
    ICON_ALIASES.documentEdit,
    ICON_ALIASES.trash,
    ICON_ALIASES.radioOff,
    ICON_ALIASES.radioOn,
    ICON_ALIASES.message,
  ]),
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  opacity: PropTypes.string,
  mixBlendMode: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Icon;
